// extracted by mini-css-extract-plugin
export default {"section":"Ut-z","sectionTitle":"Vt-z","fieldWrapper":"Wt-z","formField":"Xt-z","disabled":"Yt-z","formLabel":"Zt-z"};